import React from 'react';
import {Alert, Box, Stack} from '@mui/material';
import {Body, Button} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import LEGACY_COLORS from '@/config/legacyColors';
import styles from '../CreatorSidePanel.module.scss';

type QuickViewTabProps = {
  portfolioImages: string[];
  unreadMessagesCount: number;
  onViewMessages: () => void;
};

function QuickViewTab({
  portfolioImages,
  unreadMessagesCount,
  onViewMessages,
}: QuickViewTabProps) {
  const leftColumnImages = portfolioImages.filter(
    (_url, index) => index % 2 === 0
  );
  const rightColumnImages = portfolioImages.filter(
    (_url, index) => index % 2 === 1
  );

  return (
    <Box className={styles.tabContent}>
      {unreadMessagesCount > 0 && (
        <Alert
          severity="info"
          className={styles.unreadAlert}
          action={
            <Button
              variant="text"
              className={styles.unreadAlertAction}
              onClick={onViewMessages}
            >
              {translate('View')}
            </Button>
          }
        >
          <Body size="md" color={LEGACY_COLORS.PURPLE_DARK}>
            {translate('unread_messages', {count: unreadMessagesCount})}
          </Body>
        </Alert>
      )}

      {portfolioImages.length > 0 && (
        <Stack direction="row" className={styles.contentGrid}>
          <Stack className={styles.contentColumn}>
            {leftColumnImages.map((url) => (
              <img
                key={url}
                src={url}
                alt=""
                className={styles.contentThumbnail}
              />
            ))}
          </Stack>
          <Stack className={styles.contentColumn}>
            {rightColumnImages.map((url) => (
              <img
                key={url}
                src={url}
                alt=""
                className={styles.contentThumbnail}
              />
            ))}
          </Stack>
        </Stack>
      )}
    </Box>
  );
}

export default QuickViewTab;
